import React, { memo, useEffect, useMemo } from 'react';
import { FormArray } from '@core/utils/form';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { getFieldJSX } from './FormViewModal';
import { FCRepeaterFormData } from '@modules/settings/SettingsPage/Components/FormsTab/FormFields/FCRepeater';
import { RepeatingControls } from '@modules/common/RepeatingControls';
import { Row, Col } from 'reactstrap';
import { useLaserMeasurementConversion } from '../helpers/useLaserMeasurementConversion';

export interface FormRepeatingStepProps {
  form: FormArray<any>;
  field: FCRepeaterFormData;
  enableLaserConversion?: boolean;
}

export const FormRepeatingStep = memo((props: FormRepeatingStepProps) => {
  const { form, field, enableLaserConversion = false } = props;
  const formItems = useNonNilObservable(form.items$);
  const isColumns = useMemo(() => field.columns, [field]);
  const Wrapper = isColumns ? Col : React.Fragment;
  const ParentWrapper = isColumns ? Row : React.Fragment;

  useLaserMeasurementConversion(form, field, enableLaserConversion);

  useEffect(() => {
    if (formItems.length === 0 && field.items.length > 0) {
      form.push();
    }
  }, [field.items, form, formItems]);

  return (
    <div>
      {formItems.length === 0 && field.items.length == 0 && <div className="text-muted">Repeating form is empty</div>}
      <div>
        {formItems.map((inForm, index) => (
          <ParentWrapper key={index}>
            {field.items.map((field, i) => {
              const ctrl = inForm.controls[i];
              if (!ctrl) return <div key={i}>placeholder</div>;
              if (isColumns) return <Wrapper key={`${index}-${i}`}>{getFieldJSX(field, i, ctrl)}</Wrapper>;
              return getFieldJSX(field, i, ctrl);
            })}
            {field.items.length > 0 && (
              <Wrapper lg={2} style={{ display: 'flex', alignItems: 'center' }}>
                <RepeatingControls
                  onDuplicate={() => {
                    const ctrl = form.push();
                    ctrl.patchValue(inForm.value);
                  }}
                  duplicate
                  isLast={index === formItems.length - 1}
                  onAdd={() => form.push()}
                  onRemove={() => form.removeAt(index)}
                  style={{ marginBottom: field.columns ? 0 : 20 }}
                />
              </Wrapper>
            )}
          </ParentWrapper>
        ))}
      </div>
    </div>
  );
});
